import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getKnownPathogenicityData,
  getKnownPathogenicityValues,
} from "../../../../state/selectors/KnownPathogenicity.selector";
import { cropNumber } from "../../../../common/helpers/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { KnownPathogenicityType } from "../../../componentTypes/KnownPathogenicityType";

const GeneKnownPathogenicityCard = ({
  card,
  knownPathogenicityValues,
  knownPathogenicityData,
}) => {
  const isDisabled =
    !Object.keys(knownPathogenicityData || {}).length ||
    isEmpty(knownPathogenicityData?.items?.[0]);

  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      <div>
        {knownPathogenicityValues && (
          <span>
            <span>P+LP: </span>
            <span
              style={{
                color: `${getPathogenicityColorByAllNames("Pathogenic")}`,
              }}
              data-testid="known-pathogenicity-card-pathogenic"
              className="tw-font-bold"
            >
              {knownPathogenicityValues.pathogenic}
            </span>
            <span>,</span>
          </span>
        )}
        {knownPathogenicityValues && (
          <span>
            <span>{` VUS: `}</span>
            <span
              style={{
                color: `${getPathogenicityColorByAllNames(
                  "Uncertain Significance"
                )}`,
              }}
              data-testid="known-pathogenicity-card-uncertain"
              className="tw-font-bold"
            >
              {knownPathogenicityValues.uncertain}
            </span>
            <span>,</span>
          </span>
        )}
        {knownPathogenicityValues && (
          <span>
            <span>{` B+LB: `}</span>
            <span
              style={{
                color: `${getPathogenicityColorByAllNames("Benign")}`,
              }}
              data-testid="known-pathogenicity-card-benign"
              className="tw-font-bold"
            >
              {knownPathogenicityValues.benign}
            </span>
          </span>
        )}
      </div>
      {knownPathogenicityValues?.cutoffFrequency && (
        <div>
          {"Frequency cut-off for rule BS1 : "}
          <span
            className="tw-font-bold"
            data-testid="known-pathogenicity-card-frequency"
            style={{ color: `${getPathogenicityColorByAllNames("Benign")}` }}
          >
            {cropNumber(knownPathogenicityValues.cutoffFrequency, 2)}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneKnownPathogenicityCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  knownPathogenicityValues: PropTypes.shape({
    benign: PropTypes.number,
    uncertain: PropTypes.number,
    pathogenic: PropTypes.number,
    cutoffFrequency: PropTypes.number,
  }),
  knownPathogenicityData: KnownPathogenicityType,
};

GeneKnownPathogenicityCard.defaultProps = {
  knownPathogenicityValues: null,
  knownPathogenicityData: {},
};

const mapStateToProps = (state) => ({
  knownPathogenicityValues: getKnownPathogenicityValues(state),
  knownPathogenicityData: getKnownPathogenicityData(state),
});

export default connect(mapStateToProps, {})(GeneKnownPathogenicityCard);
